<template>
  <div class="page_body">
    <HomeTop :topTitle="topTitle"></HomeTop>
    <div class="order_body">
      <!-- 考生信息 -->
      <div class="content_card">
        <img
          class="content_card_icon"
          src="../../assets/image/success_icon01.png"
          alt="提示"
        />
        <div class="content_card_tips">报名成功</div>
        <div class="content_card_tips_g">
          （支付成功7天内或报名截止前可申请退款）
        </div>
        <div class="content_card_btn_box">
          <div class="content_card_btn" @click="toOrderDetailFn()">
            查看详情
          </div>
          <div class="content_card_btn" @click="toHomeFn()">返回首页</div>
        </div>
      </div>
    </div>
    <!-- 二维码弹窗 -->
    <div class="dialog_block" v-if="qrCodeDialogShow">
      <div class="dialog_block_box qr_code_dialog_box">
        <img
          class="dialog_block_close"
          src="../../assets/image/close_icon01.png"
          @click="closeQRCodeDialog()"
        />
        <div class="qr_code_dialog_content">
          <!-- 入群二维码 -->
          <div class="qr_code_item">
            <div class="qr_code_item_title">入群二维码</div>
            <div class="qr_code_img_box" v-if="qrCodeUrl">
              <img class="qr_code_img" :src="qrCodeUrl" alt="入群二维码" />
            </div>
            <div class="qr_code_loading" v-else>
              <div class="qr_code_loading_text">暂无二维码</div>
            </div>
          </div>
          <!-- 购买保险二维码 -->
          <div class="qr_code_item" v-if="insuranceCodeUrl">
            <div class="qr_code_item_title">领取保险二维码</div>
            <div class="qr_code_img_box">
              <img class="qr_code_img" :src="insuranceCodeUrl" alt="领取保险二维码" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="../../assets/css/order/orderSuccess.css" scoped></style>

<script>
import HomeTop from "@/components/homeTop.vue";

export default {
  name: "OrderSuccess",
  components: {
    HomeTop,
  },
  data() {
    return {
      topTitle: "提示", // 顶部组件参数设置
      orderId: "", // 订单Id
      qrCodeDialogShow: false, // 二维码弹窗显示
      qrCodeUrl: "", // 入群二维码图片地址
      insuranceCodeUrl: "", // 购买保险二维码图片地址
      baseAPIUrl: this.$store.state.baseAPIUrl,
    };
  },
  created: function () {
    let orderId = this.$route.params.orderId;
    if (orderId != undefined && orderId != "") {
      this.orderId = orderId;
    } else {
      this.orderId = this.$store.state.watchOrderId;
    }
    // 获取订单详情并显示二维码
    this.getOrderDetailAndShowQRCode();
  },
  methods: {
    // 返回首页
    toHomeFn: function () {
      this.$router.push({
        name: "Home",
      });
    },
    // 查看详情
    toOrderDetailFn: function () {
      if (this.orderId != "") {
        this.$router.push({
          name: "OrderDetail",
          params: {
            orderId: this.orderId,
          },
        });
      }
    },
    // 获取订单详情并显示二维码
    getOrderDetailAndShowQRCode: function () {
      if (!this.orderId) {
        return;
      }
      let that = this;
      let url = "/mobile/enrollOrderDetail";
      let data = {
        order_id: this.orderId,
      };
      this.axios
        .post(url, data)
        .then((response) => {
          console.log("订单详情接口返回:", response);
          if (response.code == 0) {
            // 从订单数据中获取入群二维码地址
            // 尝试多个可能的字段位置
            let qrCodePath = (response.exam && response.exam.qrcodeurl) || 
                            (response.order && response.order.qrcodeurl) || 
                            response.qrcodeurl;
            console.log("入群二维码路径:", qrCodePath);
            if (qrCodePath) {
              // 处理入群二维码URL，如果是相对路径需要添加 baseAPIUrl 前缀
              if (qrCodePath.startsWith("http://") || qrCodePath.startsWith("https://")) {
                that.qrCodeUrl = qrCodePath;
              } else {
                that.qrCodeUrl = that.baseAPIUrl + qrCodePath;
              }
            }
            
            // 从订单数据中获取购买保险二维码地址
            // 尝试多个可能的字段位置
            let insuranceCodePath = (response.exam && response.exam.insuranceurl) || 
                                   (response.order && response.order.insuranceurl) || 
                                   response.insuranceurl;
            console.log("购买保险二维码路径:", insuranceCodePath);
            if (insuranceCodePath) {
              // 处理购买保险二维码URL，如果是相对路径需要添加 baseAPIUrl 前缀
              if (insuranceCodePath.startsWith("http://") || insuranceCodePath.startsWith("https://")) {
                that.insuranceCodeUrl = insuranceCodePath;
              } else {
                that.insuranceCodeUrl = that.baseAPIUrl + insuranceCodePath;
              }
            }
            
            console.log("最终二维码URL:", {
              qrCodeUrl: that.qrCodeUrl,
              insuranceCodeUrl: that.insuranceCodeUrl
            });
            
            // 如果有任何一个二维码，就显示弹窗
            if (that.qrCodeUrl || that.insuranceCodeUrl) {
              that.qrCodeDialogShow = true;
              console.log("显示二维码弹窗");
            } else {
              console.log("没有二维码，不显示弹窗");
            }
          } else {
            // 如果获取失败，不显示弹窗，也不提示错误（因为这是自动触发的）
            console.log("获取订单详情失败:", response.msg);
          }
        })
        .catch(function (error) {
          console.log("获取订单详情失败:", error);
        });
    },
    // 关闭二维码弹窗
    closeQRCodeDialog: function () {
      this.qrCodeDialogShow = false;
      this.qrCodeUrl = "";
      this.insuranceCodeUrl = "";
    },
  },
};
</script>
